export default "__VITE_ASSET__BV4R3zSb__"